module.exports = __webpack_public_path__ + "static/media/bulma.553c0e25.svg";